{
  "common": {
    "back_to_sign_in": "Terug naar inloggen",
    "sign_out": "Uitloggen",
    "resend_code": "Code opnieuw versturen",
    "resend_in": "Opnieuw versturen over {{seconds}}s",
    "show_password": "Wachtwoord tonen",
    "hide_password": "Wachtwoord verbergen",
    "copy_secret": "Code kopiëren",
    "secret_copied": "Gekopieerd naar klembord"
  },
  "shell": {
    "tagline": "sturen op energie. bouwen aan vooruitgang.",
    "eyebrow": "NRG CMX",
    "legal": "© NRG Group {{year}}"
  },
  "sign_in": {
    "heading": "welkom terug",
    "subhead": "Log in op NRG CMX",
    "submit": "Inloggen",
    "forgot": "Wachtwoord vergeten?",
    "email": "E-mail",
    "password": "Wachtwoord"
  },
  "forgot": {
    "heading": "wachtwoord opnieuw instellen",
    "subhead": "we sturen je een 6-cijferige code per e-mail",
    "submit": "Verstuur herstelcode",
    "email": "E-mail"
  },
  "confirm_reset": {
    "heading": "voer je code in",
    "subhead": "we hebben een code gestuurd naar {{destination}}",
    "subhead_no_destination": "we hebben je een code per e-mail gestuurd",
    "submit": "Wachtwoord bijwerken",
    "code": "Verificatiecode",
    "new_password": "Nieuw wachtwoord",
    "confirm_password": "Bevestig wachtwoord"
  },
  "confirm_sign_in": {
    "heading": "voer je code in",
    "subhead_totp": "open je authenticator-app en voer de 6-cijferige code in",
    "subhead_sms": "we hebben een code naar je telefoon gestuurd",
    "subhead_email": "we hebben een code naar je e-mail gestuurd",
    "submit": "Verifiëren"
  },
  "force_new_password": {
    "heading": "kies een nieuw wachtwoord",
    "subhead": "dit is je eerste keer inloggen. Kies een wachtwoord om door te gaan.",
    "submit": "Doorgaan",
    "new_password": "Nieuw wachtwoord",
    "confirm_password": "Bevestig wachtwoord"
  },
  "setup_totp": {
    "heading": "twee-factor instellen",
    "subhead": "open je authenticator-app, voeg een nieuw account toe met onderstaande sleutel en voer daarna de 6-cijferige code in.",
    "secret_label": "Setup-sleutel",
    "secret_hint": "Tik om te kopiëren. Werkt met 1Password, Authy en Google Authenticator.",
    "submit": "Verifiëren en doorgaan"
  },
  "rules": {
    "min_length": "Minimaal {{count}} tekens",
    "uppercase": "Een hoofdletter",
    "lowercase": "Een kleine letter",
    "number": "Een cijfer",
    "symbol": "Een symbool"
  },
  "errors": {
    "email_invalid": "Voer een geldig e-mailadres in",
    "password_required": "Wachtwoord is verplicht",
    "passwords_mismatch": "Wachtwoorden komen niet overeen",
    "code_six_digits": "Voer de 6-cijferige code in",
    "password_policy_failed": "Wachtwoord voldoet niet aan de eisen",
    "cognito_invalid_credentials": "E-mail of wachtwoord is onjuist",
    "cognito_user_not_confirmed": "Bevestig je account voordat je inlogt",
    "cognito_code_mismatch": "Deze code is onjuist",
    "cognito_code_expired": "De code is verlopen - vraag een nieuwe aan",
    "cognito_limit_exceeded": "Te veel pogingen - probeer het over een paar minuten opnieuw",
    "cognito_password_policy": "Wachtwoord voldoet niet aan de eisen",
    "cognito_password_reset_required": "Je wachtwoord is opnieuw ingesteld - kies een nieuw wachtwoord om door te gaan",
    "cognito_invalid_parameter": "Een van de waardes die je hebt ingevoerd is ongeldig",
    "generic": "Er is iets misgegaan. Probeer het opnieuw."
  }
}
